import * as configData from '../../../assets/config.json';
import { GhStorageService } from './gh-storage.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigService {
  country: string;
  private config: any;

  constructor(
    private storage: GhStorageService
  ) {
    this.config = configData;
    this.country = this.storage.get('country') || 'uk'; // default to UK
  }

  get(key: any) {
    const config = this.config[this.country];
    if (config && config[key] === undefined) {
      throw new Error(`${key} does not exist in this environment`);
    }

    return config[key];
  }

  saveCountrySetting() {
    this.storage.set('country', this.country);
  }
}
